/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { getAllClothQualities } from "../../helper/utils/api/settings.js";
import { getContractWithContractId } from "../../helper/utils/api/contract.js";
import { getAllHsCode } from "../../helper/utils/api/settings.js";
import { Form, Row, Col, Select } from "antd";
import styled from "styled-components";

import {
  Loading,
  Input,
  DatePicker,
  Button,
  Typography,
  TextArea,
  Section,
  Grid,
} from "../../core";

import { MixStyle } from "../../styles";
import { addInvoice } from "../../helper/utils/api/invoice.js";
import { updateDispatch } from "../../helper/utils/api/dispatch.js";
const { Option } = Select;

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const StyledTable = styled.table`
  margin: 20px 0px;
  width: 100%;
  thead {
    background: #233b67;
    color: white;
  }
  th,
  td {
    height: 50px;
    text-align: center;
    border: 1px solid #233b67;
    font-weight: 500;
    font-size: 16px;
  }
`;

const GenerateInvoice = () => {
  let history = useHistory();
  let companyId = localStorage.getItem("companyId");
  const [state, setState] = useState("");

  const [dropDownOptions, setDropDownOption] = useState({
    clothQualitiesOptions: [],
    hsCodesOptions: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  let dispatchDetail = history.location.state;
  const [form] = Form.useForm();

  useEffect(() => {
    getContractDetails();
    setState((prev) => ({
      ...prev,
      dispatchDetail,
    }));
  }, [dispatchDetail]);

  useEffect(() => {
    getAllClothQualitiesFromDb();
    getAllHsCodeFromDb();
  }, []);

  useEffect(() => {
    dropDownOption();
    let buyerCompanyName =
      state &&
      state.contractDetail &&
      state.contractDetail.buyerCompanyId &&
      state.contractDetail.buyerCompanyId.companyName;

    let contractType =
      state &&
      state.contractDetail &&
      state.contractDetail.type &&
      state.contractDetail.type;

    let contractNo =
      state &&
      state.contractDetail &&
      state.contractDetail.contractNo &&
      state.contractDetail.contractNo;

    let netPass =
      state &&
      state.dispatchDetail &&
      state.dispatchDetail.netPass &&
      state.dispatchDetail.netPass;

    let fabricRatePerMeter =
      state &&
      state.contractDetail &&
      state.contractDetail.fabricRatePerMeter &&
      state.contractDetail.fabricRatePerMeter;

    let conversionRate =
      state &&
      state.contractDetail &&
      state.contractDetail.conversionRate &&
      state.contractDetail.conversionRate;

    form.setFieldsValue({
      buyerCompanyName,
      type: contractType,
      contractNo,
      netPass,
    });
    if (contractType === "fabric") {
      form.setFieldsValue({
        fabricRatePerMeter,
      });
    } else {
      form.setFieldsValue({
        conversionRate,
      });
    }
  }, [state]);

  useEffect(() => {
    setInvoiceData({
      dispatchId: state && state.dispatchDetail && state.dispatchDetail._id,
      contractId: state && state.contractDetail && state.contractDetail._id,
      companyId,
    });
  }, [state]);

  const getAllClothQualitiesFromDb = async () => {
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllClothQualities({ companyId });
        setState((prev) => ({
          ...prev,
          clothQualities: result,
        }));
      } catch (error) {
        console.log("error while get cloth qualities");
      }
      setIsLoading(false);
    }
  };

  const getContractDetails = async () => {
    setIsLoading(true);
    try {
      let contractIdToBeFected = dispatchDetail && dispatchDetail.contractId;
      let {
        data: { result },
      } = await getContractWithContractId(contractIdToBeFected);
      setState((prev) => ({
        ...prev,
        contractDetail: result[0],
      }));
    } catch (error) {
      console.log("error while geting active timecard", error);
    }
    setIsLoading(false);
  };

  const getAllHsCodeFromDb = async () => {
    setIsLoading(true);
    try {
      if (companyId) {
        let {
          data: { result },
        } = await getAllHsCode({ companyId });
        setState((prev) => ({
          ...prev,
          hsCode: result,
        }));
      }
    } catch (error) {
      console.log("error while geting hs Codes", error);
    }
    setIsLoading(false);
  };

  const dropDownOption = () => {
    let clothQualitiesOptions =
      state &&
      state.clothQualities &&
      state.clothQualities.map((clothQuality) => {
        let optionObj = {
          label: `${clothQuality.reed} * ${clothQuality.pick} / ${clothQuality.warp} * ${clothQuality.weft} = ${clothQuality.width}" ${clothQuality.type}`,
          value: clothQuality._id,
        };
        return optionObj;
      });

    let hsCodesOptions =
      state && state.hsCode && state.hsCode.map(({ hsCode }) => hsCode);

    setDropDownOption((prev) => ({
      ...prev,
      clothQualitiesOptions,
      hsCodesOptions,
    }));
  };

  const onValuesChange = (changedValues, values) => {
    debugger;
    console.log("changedValues, values", changedValues, values);

    let invoiceTotalExcludeTax =
      state &&
      state.dispatchDetail &&
      state.dispatchDetail.clothReturnVariations.length > 0
        ? state.dispatchDetail.clothReturnVariations
            .map((data) => data.quantity * data.rate)
            .reduce((acc, curr) => acc + curr)
        : parseFloat(
            values.type === "fabric"
              ? values.fabricRatePerMeter
              : values.conversionRate
          ) * parseFloat(values.netPass);

    debugger;
    let totalTaxRate = 0;
    if (values && values.tax && invoiceTotalExcludeTax) {
      totalTaxRate = (invoiceTotalExcludeTax * parseFloat(values.tax)) / 100;
    }

    let invoiceTotalIncludeTax = totalTaxRate + invoiceTotalExcludeTax;

    form.setFieldsValue({
      invoiceTotalExcludeTax,
      totalTaxRate,
      invoiceTotalIncludeTax,
    });

    setInvoiceData((prev) => ({
      ...prev,
      ...values,
      invoiceTotalExcludeTax,
      totalTaxRate,
      invoiceTotalIncludeTax,
    }));

    // console.log("totalExcludeTax", invoiceTotalExcludeTax);
    // console.log("totalTaxRate", totalTaxRate);
    // console.log("invoiceTotalIncludeTax", invoiceTotalIncludeTax);
  };

  const onFinish = (values) => {
    addInvoiceToDb(values);
  };

  const addInvoiceToDb = async () => {
    setIsLoading(true);
    console.log("invoiceData", invoiceData);

    if (
      state &&
      state.dispatchDetail &&
      state.dispatchDetail.clothReturnVariations
    ) {
      let finalPayload = {
        ...invoiceData,
        clothReturnVariations:
          state &&
          state.dispatchDetail &&
          state.dispatchDetail.clothReturnVariations,
      };
      try {
        let response = await addInvoice(finalPayload);
        await updateDispatchInvoiceStatus();
        console.log("response addInvoice", response);
      } catch (error) {
        console.log("error=> addInvoice", error);
      }
      setIsLoading(false);
    } else {
      let finalPayload = {
        ...invoiceData,
      };
      try {
        let response = await addInvoice(finalPayload);
        await updateDispatchInvoiceStatus();
        console.log("response addInvoice", response);
      } catch (error) {
        console.log("error=> addInvoice", error);
      }
      setIsLoading(false);
    }
  };

  const updateDispatchInvoiceStatus = async () => {
    debugger;
    let updatedValue = {
      invoiceStatus: "generated",
    };
    let contractId = dispatchDetail && dispatchDetail.contractId;
    setIsLoading(true);
    try {
      let dispatchIdToEdit =
        state && state.dispatchDetail && state.dispatchDetail._id;
      await updateDispatch({
        contractId,
        dispatchIdToEdit,
        updatedValue,
      });
      // history.push(
      //   `contract-inner/${
      //     state && state.contractDetail && state.contractDetail.contractNo
      //   }`
      //   dispatchDetail && dispatchDetail.contractId
      // );
      history.push({
        pathname: `contract-inner/${
          state && state.contractDetail && state.contractDetail.contractNo
        }`,
        state: dispatchDetail && dispatchDetail.contractId,
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error while update", error);
    }
  };

  console.log("history=>");
  return (
    <Grid>
      {isLoading && <Loading />}
      <Section padding="20px">
        <StyledForm
          autocomplete="off"
          form={form}
          {...layout}
          name="basic"
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          // onFinishFailed={onFinishFailed}
        >
          <Row
            gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
            type="flex"
            justify="end"
          >
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Invoice #"
                name="invoiceNumber"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Invoice No",
                  },
                ]}
              >
                <Input placeholder="Invoice #" />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Invoice Date"
                name="invoiceDate"
                rules={[
                  {
                    required: true,
                    message: "Please Set Invoice invoiceDate!",
                  },
                ]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Buyer Company Name"
                name="buyerCompanyName"
                rules={[
                  {
                    required: true,
                    message: "Buyer Company Name is not Entered",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Contract Type"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Contract type is not Entered",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Cloth Quality"
                name="clothQuality"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Cloth Quality",
                  },
                ]}
              >
                <Select
                  defaultValue=""
                  placeholder="Reed * Pick / Warp * Weft = width″ Type"
                >
                  <Option value="">select cloth Quality</Option>
                  {dropDownOptions &&
                    dropDownOptions.clothQualitiesOptions &&
                    dropDownOptions.clothQualitiesOptions.map(
                      (clothQuality) => (
                        <Option value={clothQuality.label}>
                          {clothQuality.label}
                        </Option>
                      )
                    )}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Net Pass"
                name="netPass"
                rules={[
                  {
                    required: true,
                    message: "Net pass is not enterd",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col md={8} sm={18} xs={24}>
              <Form.Item label="GST %" name="tax">
                {/* <Input /> */}
                <Select placeholder="Tax Rate">
                  <Option value="">select tax</Option>
                  <Option value="17">gsl/17%</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col md={8} sm={18} xs={24}>
              <Form.Item
                label="Contract #"
                name="contractNo"
                rules={[
                  {
                    required: true,
                    message: "please Enter Contract No",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={8} sm={18} xs={24}>
              <Form.Item
                label="HS Code"
                name="hsCode"
                rules={[
                  {
                    required: true,
                    message: "Please Select HS code",
                  },
                ]}
              >
                <Select defaultValue="">
                  <Option value="">select Weave</Option>
                  {dropDownOptions &&
                    dropDownOptions.hsCodesOptions &&
                    dropDownOptions.hsCodesOptions.map((hsCode) => (
                      <Option value={hsCode}>{hsCode}</Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={12} sm={18} xs={24}>
              {state &&
              state.contractDetail &&
              state.contractDetail.type === "fabric" ? (
                <Form.Item
                  label="Rate/MTR"
                  name="fabricRatePerMeter"
                  rules={[
                    {
                      required: true,
                      message: "Rate/MTR is not Entered",
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              ) : (
                <Form.Item
                  label="Conversion Rate"
                  name="conversionRate"
                  rules={[
                    {
                      required: true,
                      message: "Conversion Rate Is Required",
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              )}
            </Col>

            <Col md={24}>
              <Form.Item
                label="Invoice Note "
                name="invoiceNote"
                rules={[
                  {
                    required: false,
                    message: "Please Enter Invoice Note",
                  },
                ]}
              >
                <TextArea />
              </Form.Item>
            </Col>
            {console.log("state", state)}
            {state &&
              state.dispatchDetail &&
              state.dispatchDetail.clothReturnVariations &&
              state.dispatchDetail.clothReturnVariations.length > 0 && (
                <Col md={12} sm={18} xs={24}>
                  {/* const delivery_schedule = JSON.parse(delivery_data); */}
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Sr #</th>
                        <th>Cattagories</th>
                        <th>Quanity</th>
                        <th>Rate/MTR</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state.dispatchDetail.clothReturnVariations.map(
                        (data, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{data.category}</td>
                              <td>{data.quantity}</td>
                              <td>{data.rate}</td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </StyledTable>
                </Col>
              )}
            <Col md={12} sm={18} xs={24}></Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Invoice Total Exclude Tax"
                name="invoiceTotalExcludeTax"
                rules={[
                  {
                    required: true,
                    message: "Invoice Total Exclude Tax",
                  },
                ]}
              >
                <Input disabled placeholder="Invoice Total Ex Tax" />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}></Col>

            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Total Tax"
                name="totalTaxRate"
                rules={[
                  {
                    required: true,
                    message: "Total Tax",
                  },
                ]}
              >
                <Input disabled placeholder="Total Tax" />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}></Col>

            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Invoice Total Include Tax"
                name="invoiceTotalIncludeTax"
                rules={[
                  {
                    required: true,
                    message: "Invoice total include tax",
                  },
                ]}
              >
                <Input disabled placeholder="Invoice Total Include Tax" />
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
            type="flex"
            justify="between"
          >
            {/* <Link to={{
                pathname:"",
                state:"usa,ma"
              }} */}
            {/* <Button width="187px" bg="#404E67" type="primary">
              <Typography
                text="Print Invoice"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button> */}
            {/* <Button width="187px" bg="#404E67" type="primary">
              <Typography
                text="Print and Save Invoice"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button> */}
            <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
              <Typography
                text="Save Invoice"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button>
          </Row>
        </StyledForm>
      </Section>
    </Grid>
  );
};

export default GenerateInvoice;
